import useRequest from '@/websdk/utils/request';

export default (function () {
  const { exec, isRequestSuccessed } = useRequest({
    url: '/api/system/logout',
    name: 'PUT_LOGOUT_TIME',
    method: 'PUT',
  });

  return [exec, isRequestSuccessed];
});
